export interface Bonus {
  id: string
  title: string
  subtitle: string
  intro?: string
  bulletsIntro?: string
  bullets?: string[]
  secondaryBulletsIntro?: string
  secondaryBullets?: string[]
  systemLabel?: string
  system?: string
  closing?: string[]
}

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: 'Professional Grooming Tools, Blades & Equipment Handbook',
    subtitle: 'Understand the tool. Choose it correctly. Teach students how to use it.',
    bulletsIntro: 'A practical instructor reference covering:',
    bullets: [
      'Clippers',
      'Blades',
      'Guard combs',
      'Straight scissors',
      'Curved scissors',
      'Thinning shears',
      'Chunkers',
      'Brushes',
      'Combs',
      'De-shedding tools',
      'Dryers',
      'Grooming tables',
      'Equipment setup',
      'Tool maintenance',
      'Cleaning',
      'Storage',
      'Common tool-selection mistakes',
    ],
    closing: [
      'Stop simply naming the tools.',
      'Start helping students understand why, when and how each one is used.',
    ],
  },
  {
    id: '2',
    title: 'Canine Coat Types & Grooming Decision Guide',
    subtitle: 'Know what you are working with before choosing the technique.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Major canine coat categories',
      'Coat texture',
      'Coat density',
      'Coat condition',
      'Grooming considerations',
      'Brushing requirements',
      'Preparation needs',
      'Drying considerations',
      'Tool selection',
      'Technique decisions',
      'Maintenance considerations',
      'Common coat-related mistakes',
    ],
    systemLabel: 'Core system:',
    system: 'IDENTIFY → ASSESS → CHOOSE → PREPARE → GROOM',
  },
  {
    id: '3',
    title: 'Common Grooming Mistakes, Corrections & Troubleshooting Manual',
    subtitle: 'See the problem. Find the cause. Apply the fix.',
    bulletsIntro: 'A practical diagnostic resource covering problems such as:',
    bullets: [
      'Clipper tracks',
      'Uneven body length',
      'Poor blending',
      'Hard transition lines',
      'Uneven legs',
      'Legs trimmed too thin',
      'Uneven feet',
      'Head too large',
      'Muzzle imbalance',
      'Ear asymmetry',
      'Poor scissor control',
      'Incorrect tool selection',
      'Workflow problems',
      'Finishing problems',
    ],
    systemLabel: 'Core system:',
    system: 'PROBLEM → CAUSE → CORRECTION → PRACTICE → RECHECK',
  },
  {
    id: '4',
    title: '30 Ready-to-Teach Dog Grooming Class Plans',
    subtitle: 'Build better classes without starting from zero.',
    bulletsIntro: 'Includes structured classes covering:',
    bullets: [
      'Professional setup',
      'Tools',
      'Coat assessment',
      'Coat preparation',
      'Brushing',
      'De-shedding',
      'Drying',
      'Clippers',
      'Blade selection',
      'Body grooming',
      'Scissor control',
      'Blending',
      'Leg shaping',
      'Foot finishing',
      'Head shaping',
      'Ear styling',
      'Tail finishing',
      'Symmetry',
      'Corrections',
      'Complete grooming workflow',
    ],
    secondaryBulletsIntro: 'Each class can include:',
    secondaryBullets: [
      'Objective',
      'Student level',
      'Required tools',
      'Instructor preparation',
      'Demonstration',
      'Student practice',
      'What to observe',
      'Common errors',
      'Correction cues',
      'Quick assessment',
      'Easier version',
      'Advanced progression',
    ],
  },
  {
    id: '5',
    title: 'Student Skills Assessment & Progress Tracker',
    subtitle: 'Know where your student is — and what they should work on next.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Student profiles',
      'Skill assessments',
      'Practical checklists',
      'Progress tracking',
      'Tool-control evaluation',
      'Coat-preparation assessment',
      'Clipper assessment',
      'Scissor assessment',
      'Styling assessment',
      'Workflow organization',
      'Final-finish assessment',
      'Instructor notes',
      'Next-skill objectives',
    ],
    secondaryBulletsIntro: 'Assessment areas include:',
    secondaryBullets: [
      'Preparation',
      'Coat assessment',
      'Tool selection',
      'Clippers',
      'Scissors',
      'Blending',
      'Body balance',
      'Leg symmetry',
      'Head balance',
      'Detail work',
      'Safety awareness',
      'Workflow',
      'Final finish',
    ],
  },
]
